import { ErrorOutline, WarningAmber } from '@mui/icons-material';
import styled from 'styled-components';

// Our class ui repo is overriding Alert styling, turning all alerts blue regardless of variant.
// This is a workaround to get the error alert to display correctly.

const StyledAlert = styled.div<{ severity: 'error' | 'warning' }>`
    padding: 6px 16px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    background-color: ${({ severity }) => (severity === 'error' ? 'rgb(253, 236, 236)' : 'rgb(255, 244, 229)')};
    color: ${({ severity }) => (severity === 'error' ? 'rgb(95, 26, 26)' : 'rgb(102, 60, 0)')};
`;

const IconWrapper = styled.span<{ severity: 'error' | 'warning' }>`
    margin-right: 12px;
    margin-top: 6px;
    display: flex;
    color: ${({ severity }) => (severity === 'error' ? '#EB1414' : '#FF6F00')};
`;

const ContentWrapper = styled.div`
    padding: 8px 0;
`;

const Alert = ({ severity = 'error', children }: { severity: 'error' | 'warning'; children?: any }) => (
    <StyledAlert severity={severity}>
        <div style={{ display: 'flex' }}>
            {severity === 'error' && (
                <IconWrapper severity={severity}>
                    <ErrorOutline />
                </IconWrapper>
            )}
            {severity === 'warning' && (
                <IconWrapper severity={severity}>
                    <WarningAmber />
                </IconWrapper>
            )}
            <ContentWrapper>{children}</ContentWrapper>
        </div>
    </StyledAlert>
);

export { Alert };
